var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-164 42.3 512 512",
    style: {
      enableBackground: "new -164 42.3 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#843B90;}\n\t.st1{fill:#7ED5C5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -121.3,
    y: 447.6,
    className: "st0",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -121.3,
    y: 490.3,
    className: "st0",
    width: 85.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-14.7,212.9L-14.7,212.9l-106.7,0.1v-10.7c0-5.9,4.8-10.7,10.7-10.7H-36v-21.3h-74.7c-17.7,0-32,14.3-32,32 v12.5c-12.4,4.4-21.3,16.2-21.3,30.2v277.3c0,17.7,14.3,32,32,32h384c13.9,0,25.8-8.9,30.2-21.3h12.5c17.7,0,32-14.3,32-32v-74.7 c13-9.7,21.3-25.2,21.3-42.7s-8.4-32.9-21.3-42.7v-21.3h-21.3v11.7c-3.4-0.7-7-1.1-10.7-1.1H284v-23.4v-8.6v-21.3v-32 c0-17.7-14.3-32-32-32H6.7v-0.1H-14.7z M305.3,500.9L305.3,500.9c0,5.9-4.8,10.7-10.7,10.7H284v-74.7h10.7 c3.7,0,7.2-0.4,10.7-1.1V500.9z M294.7,351.6c17.7,0,32,14.3,32,32c0,17.7-14.3,32-32,32H252c-17.7,0-32-14.3-32-32 c0-17.7,14.3-32,32-32H294.7z M252,234.3c5.9,0,10.7,4.8,10.7,10.7v85.3H252c-29.5,0-53.3,23.9-53.3,53.3 c0,29.5,23.9,53.3,53.3,53.3h10.7v85.3c0,5.9-4.8,10.7-10.7,10.7h-384c-5.9,0-10.7-4.8-10.7-10.7V244.9c0-5.9,4.8-10.7,10.7-10.7 H252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.7,191.6H284v-21.3H6.7V63.6H284V42.3H-4c-5.9,0-10.7,4.8-10.7,10.7v159.9H6.7V191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.7,276.9H284v21.3h53.3c5.9,0,10.7-4.8,10.7-10.7v-74.7h-21.3V276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.3,42.3H284v21.3h42.7v106.7H284v21.3h42.7v21.3H348V52.9C348,47.1,343.2,42.3,337.3,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.7,84.9c-8.2,0-15.7,3.1-21.3,8.2C75.7,88,68.2,84.9,60,84.9c-17.7,0-32,14.3-32,32 c0,17.7,14.3,32,32,32c8.2,0,15.7-3.1,21.3-8.2c5.7,5.1,13.1,8.2,21.3,8.2c17.7,0,32-14.3,32-32 C134.7,99.3,120.3,84.9,102.7,84.9z M60,127.6c-5.9,0-10.7-4.8-10.7-10.7s4.8-10.7,10.7-10.7s10.7,4.8,10.7,10.7 S65.9,127.6,60,127.6z M102.7,127.6c-5.9,0-10.7-4.8-10.7-10.7s4.8-10.7,10.7-10.7s10.7,4.8,10.7,10.7S108.6,127.6,102.7,127.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 106.3,
    className: "st1",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 106.3,
    className: "st1",
    width: 42.7,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 106.3,
    className: "st1",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.3,
    y: 372.9,
    className: "st0",
    width: 21.3,
    height: 21.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.07b800bd3917994134d1a3d6157f4d29.svg";
export { ForwardRef as ReactComponent };